define('core/extensions/helpers/urlfor',[
    'core/config/urls',
    'core/utils/object/get',
], function (
    urls,
    get
) {
    'use strict';

    return function (propName) {
        return get(urls, propName.split('.'));
    };
});

